import axios from '../config/api'
import { deepCopy } from '@/utils/utils'
import { PRODUCT_TYPE } from '@/config/product'

const state = () => ({
  delivery: 'delivery',
  cartSummaryData: null,
  showSummary: true,
  // OLD: single-coupon state, kept for rollback reference — superseded by `coupons` / `couponRequest` below
  // coupon: {
  //   code: '',
  //   data: null,
  //   autoAddToCart: null,
  //   discountAmount: 0,
  //   isError: false,
  //   isLoading: false,
  //   message: '',
  //   status: 200,
  // },
  coupons: [],
  couponRequest: {
    isLoading: false,
    isError: false,
    message: '',
    status: 200,
    data: null,
  },
  isLoading: false,
})

// getters
const getters = {
  haveDeposit: state => {
    return state.delivery === false
  },

  priceDeposit: (state, getters, root) => {
    const sku = root.model.selectSKU
    return sku?.price_deposit || 0
  },

  priceBundle: (state, getters, root) => {
    const sku = root.model.selectSKU
    const selecteds = root.bundle.selects
    const delivery = root.cart.delivery

    const bundles = sku?.bundle_product
    const amount = bundles?.reduce((crr, item) => {
      if (selecteds[item.sku]) {
        crr +=
          parseInt(selecteds[item.sku]) *
          parseInt(delivery ? item.price_ship : item.price_store)
      }
      return crr
    }, 0)

    return amount
  },

  priceAdditional: (state, getters, root) => {
    const selecteds = root.bundle.selects
    const delivery = root.cart.delivery

    const additionalProduct = deepCopy(root.model.additionalProduct)

    const amount = additionalProduct?.reduce((crr, item) => {
      item.products.map(p => {
        if (selecteds[p.sku]) {
          crr +=
            parseInt(selecteds[p.sku]) *
            parseInt(delivery ? p.price_ship : p.price_store)
        }
      })
      return crr
    }, 0)
    return amount ?? 0
  },

  priceDelivery: (state, getters, root) => {
    const sku = root.model.selectSKU
    const selecteds = root.bundle.delivery
    const delivery = root.cart.delivery

    const bundles = sku?.bundle_product
    const amount = bundles?.reduce((crr, item) => {
      if (selecteds[item.sku]) {
        crr +=
          parseInt(selecteds[item.sku]) *
          parseInt(delivery ? item.price_ship : item.price_store)
      }
      return crr
    }, 0)

    return amount
  },

  priceSummary: (state, getters, root) => {
    const sku = root.model?.selectSKU

    // const discountAmount =
    //   root.branchStore.branchType ===
    //     branchTypes.BRANCH_TYPE_DEPOSIT &&
    //   root.cart.delivery === 'store'
    //     ? 0
    //     : state.coupon.discountAmount
    // OLD: const discountAmount = state.coupon.discountAmount
    const discountAmount = state.coupons.reduce(
      (sum, c) => sum + (+c.discountAmount || 0),
      0,
    )

    const priceSummary =
      parseInt(sku?.price) +
      getters.priceBundle +
      getters.priceDelivery +
      getters.priceAdditional -
      discountAmount

    return priceSummary
  },

  discountOnTop: (_, getters, __, rootGetters) => {
    const paymentType =
      rootGetters?.['paymentType/getCurrentPaymentType'] ?? null
    const discountOnTopPercent =
      paymentType?.on_top_discount_percent ?? 0
    const discountOnTopAmount =
      (getters.priceSummary * discountOnTopPercent) / 100
    return paymentType ? discountOnTopAmount : 0
  },

  cartItems: (state, getters, root) => {
    const sku = root?.model?.selectSKU
    const selecteds = root?.bundle?.selects
    const bundles = sku?.bundle_product
    let additional = []

    deepCopy(root?.model?.additionalProduct)?.map(a => {
      a.products?.map(item => {
        item.count = selecteds[item.sku] || 0
        item.amount = parseInt(item.price) * parseInt(item.count)
        additional.push({
          sku: item.sku,
          name: item.name,
          price: item.price,
          price_srp: item.price_srp,
          price_ship: item.price_ship,
          price_store: item.price_store,
          amount: item.amount,
          count: item.count,
          imageUrl: item.image_url,
          active: item.active,
          type: 'additional_product',
        })
      })
    })

    const items = deepCopy(bundles)
      ?.map(b => {
        b.count = selecteds[b.sku] || 0
        b.amount = parseInt(b.price) * parseInt(b.count)
        return {
          sku: b.sku,
          name: b.name,
          price: b.price,
          price_srp: b.price_srp,
          price_ship: b.price_ship,
          price_store: b.price_store,
          amount: b.amount,
          count: b.count,
          imageUrl: b.image_url,
          active: b.active,
          type:
            b.type === PRODUCT_TYPE.WARRANTY
              ? b.type
              : PRODUCT_TYPE.CART_BUNDLE,
          isPromotion: b.type === PRODUCT_TYPE.PROMOTION,
          isFreeBie: b.type === PRODUCT_TYPE.FREE,
          isUnsetFree: b.type === PRODUCT_TYPE.UNSET_FREE,
          isFreeBieMember: b.type === PRODUCT_TYPE.FREE_MEMBER,
          isFreeAccessory:
            b.type === PRODUCT_TYPE.ACCESSORY &&
            parseFloat(b.price_ship) <= 0 &&
            parseFloat(b.price_store) <= 0,
          condition: b.condition ?? [],
        }
      })
      ?.filter(b => b.count > 0)

    return [
      {
        sku: sku?.sku,
        name: sku?.name,
        price: sku?.price,
        amount: sku?.price,
        price_srp: sku?.price_srp,
        price_ship: sku?.price,
        price_store: sku?.price,
        imageUrl: sku?.image_url,
        count: 1,
        type: 'main_product',
      },
      ...items,
      ...additional?.filter(b => b.count > 0),
    ].sort((a, b) => {
      return (
        (a.type === PRODUCT_TYPE.MAIN_PRODUCT ? -1 : 0) +
        (b.type === PRODUCT_TYPE.MAIN_PRODUCT ? 1 : 0) +
        (a.isFreeBie ? 1 : 0) -
        (b.isFreeBie ? 1 : 0) +
        (a.isFreeBieMember ? 1 : 0) -
        (b.isFreeBieMember ? 1 : 0) +
        (a.isPromotion ? 1 : 0) -
        (b.isPromotion ? 1 : 0)
      )
    })
  },

  productItem: (state, getters, root) => {
    return root.model.selectSKU
  },

  bundleItems: (state, getters, root) => {
    const selecteds = root.bundle.selects
    const keys = Object.keys(selecteds)
    return keys.map(k => ({
      sku: k,
      unit: selecteds[k],
    }))
  },

  deliveryItems: (state, getters, root) => {
    const selecteds = root.bundle?.delivery
    const keys = Object.keys(selecteds)
    return keys?.map(k => ({
      sku: k,
      unit: selecteds?.[k],
    }))
  },

  isAppliedHandraiserCoupon: state => {
    return state.coupons?.some(c => c.handraiser) ?? false
  },
}

// actions
const actions = {
  showSummary({ commit }, payload) {
    if (screen.width <= 760) {
      commit('showSummary', payload)
    }
  },

  // OLD: single-coupon redeem action, kept for rollback reference — superseded by `addCouponCode` below
  // async checkCouponCode({ commit }, payload) {
  //   try {
  //     commit('resetCouponCode')
  //
  //     commit('setCouponCodeRequest')
  //     const {
  //       productId,
  //       couponCode,
  //       bundleItems,
  //       paymentTypeId,
  //       memberId,
  //     } = payload
  //     const jsonData = {
  //       product_id: productId,
  //       code: couponCode,
  //       bundle_selected: bundleItems?.filter(i => i?.unit > 0) ?? [],
  //       payment_type_id: paymentTypeId,
  //       member_id: memberId || null,
  //       is_stockcard: payload?.isStockCard || false,
  //     }
  //     // const res = await axios.get(
  //     //   `/coupon-product/${productId}/code/${couponCode}`,
  //     // )
  //     const res = await axios.post(`/redeem-coupon`, jsonData)
  //     const { data } = res
  //     commit('setCouponCode', data?.data)
  //   } catch (e) {
  //     commit('setCouponCodeError', e.response.data)
  //   }
  // },

  async addCouponCode(
    {
      commit,
      // state
    },
    payload,
  ) {
    try {
      commit('setCouponRequestLoading')
      const {
        productId,
        couponCode,
        appliedCodes,
        bundleItems,
        paymentTypeId,
        memberId,
      } = payload

      const jsonData = {
        product_id: productId,
        code: couponCode,
        codes: appliedCodes,
        bundle_selected: bundleItems?.filter(i => i?.unit > 0) ?? [],
        payment_type_id: paymentTypeId,
        member_id: memberId || null,
        is_stockcard: payload?.isStockCard || false,
      }

      const res = await axios.post(`/redeem-coupon`, jsonData)
      const { data } = res
      commit('addCoupon', data)
      return { success: true }
    } catch (e) {
      commit('setCouponRequestError', e.response.data)
      return { success: false }
    }
  },

  async cartSummary({ commit }, payload) {
    try {
      // delete key if value is null
      // TODO: [CART_SUMMARY] Add a transform here to allow only the keys that the API needs.
      Object.keys(payload).forEach(
        key => payload[key] == null && delete payload[key],
      )
      commit('setLoading', true)
      commit('setCartSummaryData')
      const res = await axios.post(`/cart/summary`, payload)
      const { data } = res
      commit('setCartSummaryData', data?.data)
      commit('setLoading', false)
    } catch (e) {
      commit('setCartSummaryDataError')
      commit('setLoading', false)
    }
  },

  setDelivery({ commit, dispatch }, value) {
    commit('delivery', value)
    if (value === 'store') {
      dispatch('bundle/resetDelivery', null, { root: true })
    }
  },

  isCouponCodeApplied({ state }, couponCode) {
    return (
      state.coupons?.some(
        c => c.code.toLowerCase() === couponCode.toLowerCase(),
      ) ?? false
    )
  },
}

// mutations
const mutations = {
  showSummary(state, payload) {
    state.showSummary = payload
  },
  setLoading(state, value) {
    state.isLoading = value
  },
  delivery(state, value) {
    state.delivery = value
  },
  resetCouponCode(state) {
    // OLD:
    // state.coupon = {
    //   code: '',
    //   data: null,
    //   autoAddToCart: null,
    //   discountAmount: 0,
    //   isError: false,
    //   isLoading: false,
    // }
    state.coupons = []
    state.couponRequest = {
      isLoading: false,
      isError: false,
      message: '',
      status: 200,
      data: null,
    }
  },
  // OLD: single-coupon mutations, kept for rollback reference — superseded by the coupon-request/coupons mutations below
  // setCouponCodeRequest(state) {
  //   state.coupon = {
  //     code: '',
  //     discount: 0,
  //     finalAmount: 0,
  //     remaining: 0,
  //     message: '',
  //     isError: false,
  //     isLoading: true,
  //   }
  // },
  // async setCouponCode(state, value) {
  //   state.coupon = {
  //     code: value?.code,
  //     autoAddToCart: value?.auto_add_to_cart,
  //     discountAmount: +value?.discount_amount,
  //     message: value?.message,
  //     status: value?.status,
  //     isError: false,
  //     isLoading: false,
  //   }
  // },
  // setCouponCodeError(state, value) {
  //   state.coupon = {
  //     code: '',
  //     data: value?.data,
  //     discountAmount: 0,
  //     message: value?.message,
  //     status: value?.status,
  //     isError: true,
  //     isLoading: false,
  //   }
  // },
  setCouponRequestLoading(state) {
    state.couponRequest = {
      isLoading: true,
      isError: false,
      message: '',
      status: 200,
      data: null,
    }
  },
  setCouponRequestError(state, value) {
    state.couponRequest = {
      isLoading: false,
      isError: true,
      message: value?.message,
      status: value?.status,
      data: value?.data,
    }
  },
  addCoupon(state, response) {
    const coupons = response?.data ?? []

    coupons.forEach(coupon => {
      const existingIndex = state.coupons.findIndex(
        c => c.code === coupon?.code,
      )

      if (existingIndex !== -1) {
        // Update existing coupon
        state.coupons[existingIndex] = {
          code: coupon?.code,
          discountAmount: +coupon?.discount_amount,
          discountType: coupon?.discount_type,
          position: coupon?.position,
          autoAddToCart: coupon?.auto_add_to_cart ?? [],
          handraiser: coupon.handraiser == 1,
        }
      } else {
        // Add new coupon
        state.coupons.push({
          code: coupon?.code,
          discountAmount: +coupon?.discount_amount,
          discountType: coupon?.discount_type,
          position: coupon?.position,
          autoAddToCart: coupon?.auto_add_to_cart ?? [],
          handraiser: coupon.handraiser == 1,
        })
      }
    })

    state.couponRequest = {
      isLoading: false,
      isError: false,
      message: response?.message,
      status: response?.status,
      data: null,
    }
  },
  removeCoupon(state, code) {
    state.coupons = state.coupons.filter(
      c => c.code.toLowerCase() !== code.toLowerCase(),
    )
  },
  setCartSummaryData(state, value) {
    state.cartSummaryData = value
  },
  setCartSummaryDataError(state) {
    state.cartSummaryData = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
